import { Alert } from "@/shared/feedback/alert";
import { useTranslations } from "use-intl";

export function EgovSigningInstruction() {
  const t = useTranslations("Signing");

  return (
    <Alert
      type={"info"}
      message={t("EGOV_SIGNING_INSTRUCTION_TITLE")}
      description={
        <ol className={"list-decimal list-inside text-xs"}>
          <li>
            {t("EGOV_SIGNING_INSTRUCTION_OPEN_APP")}
            <ul className={"list-disc list-inside pl-3"}>
              <li>{t("EGOV_SIGNING_INSTRUCTION_OPEN_APP_FOR_PHYSICAL")}</li>
              <li>{t("EGOV_SIGNING_INSTRUCTION_OPEN_APP_FOR_LEGAL")}</li>
            </ul>
          </li>
          <li>{t("EGOV_SIGNING_INSTRUCTION_OPEN_QR")}</li>
          <li>{t("EGOV_SIGNING_INSTRUCTION_OPEN_SCAN_QR")}</li>
        </ol>
      }
    />
  );
}
